import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ChevronDown } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { BANNER_HEIGHT, BREADCRUMBS_HEIGHT, TEXT } from '../../config/constants';
import ButtonLink from '../ButtonLink';
import Image from '../Image';
import css from './ImageWithJumper.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ImageWithJumper = function ImageWithJumper(_ref) {
  var cta = _ref.cta,
      imageDesktop = _ref.imageDesktop,
      imageMobile = _ref.imageMobile,
      title = _ref.title;
  var rootRef = useRef();
  var titleRef = useRef();

  var _useState = useState(114),
      _useState2 = _slicedToArray(_useState, 2),
      titleHeight = _useState2[0],
      setTitleHeight = _useState2[1];

  var scrollToContent = function scrollToContent() {
    var rootEl = rootRef.current;

    if (!rootEl) {
      return false;
    }

    var top = rootEl.offsetHeight + BANNER_HEIGHT + BREADCRUMBS_HEIGHT;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
    return true;
  };

  useEffect(function () {
    var titleEl = titleRef.current;

    if (!titleEl) {
      return;
    }

    var halfElHeight = titleEl.offsetHeight ? titleEl.offsetHeight / 2 : 0;
    var newTitleHeight = halfElHeight + BANNER_HEIGHT;
    setTitleHeight(newTitleHeight);
  }, [titleRef]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("header", {
      className: css.root,
      ref: rootRef,
      children: [/*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageDesktop), {}, {
        alt: title,
        className: css.desktop,
        lazyload: false,
        sizes: [800, 1200, 1600]
      })), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageMobile), {}, {
        alt: title,
        className: css.mobile,
        lazyload: false,
        sizes: [480, 600]
      })), /*#__PURE__*/_jsxs("div", {
        className: css.text,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.topSpacer
        }), /*#__PURE__*/_jsxs("div", {
          className: css.centerText,
          style: {
            bottom: "calc(50vh - ".concat(titleHeight, "px)")
          },
          ref: titleRef,
          children: [/*#__PURE__*/_jsx("h1", {
            className: css.title,
            dangerouslySetInnerHTML: {
              __html: title
            }
          }), cta && /*#__PURE__*/_jsx(ButtonLink, {
            big: true,
            medium: true,
            className: css.cta,
            href: cta.href,
            white: true,
            children: cta.text
          })]
        }), /*#__PURE__*/_jsxs("button", {
          "aria-hidden": "false",
          "aria-label": TEXT.scrollDown,
          className: css.jumper,
          onClick: scrollToContent,
          title: TEXT.scrollDown,
          type: "button",
          children: ["Explore", /*#__PURE__*/_jsx(ChevronDown, {})]
        })]
      })]
    })
  });
};

ImageWithJumper.defaultProps = {
  cta: false
};
ImageWithJumper.propTypes = {
  cta: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  imageDesktop: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  imageMobile: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  title: PropTypes.string.isRequired
};
export default ImageWithJumper;